import io from 'socket.io-client'
export const overrideStyle = {
  display: 'flex',
  margin: '0 auto',
  height: '24px',
  justifyContent: 'center',
  alignItems: 'center',
}
// export const socket = io('http://localhost:5000')
// export const socket = io('https://api.365promo.net', {
//   autoConnect: true, // Automatically reconnect
//   reconnectionAttempts: 5, // Retry if the connection is lost
// })
export const socket = io('https://api.snusconicotine.com', {
  transports: ['websocket'],
  withCredentials: true,
  autoConnect: true,
  reconnectionAttempts: 5,
})
